import { useCallback } from "react";
import { removeAllCookies } from "@lib/cookies";
import { useReloadHomePageWithQuery } from "../useReloadHomePageWithQuery/useReloadHomePageWithQuery";

/**
 * Resets the session by clearing all cookies and local storage, and reloading the home page with the plan_id query parameter removed.
 * @returns A function that resets the session.
 */
export const useSessionReset = () => {
  const reloadHomePageWithQuery = useReloadHomePageWithQuery();

  return useCallback(
    async (shouldHardReload = false) => {
      await removeAllCookies();
      localStorage.clear();
      reloadHomePageWithQuery(["plan_id"], shouldHardReload);
    },
    [reloadHomePageWithQuery],
  );
};
